import { FC } from "react";
import { Link } from "react-router-dom";
import { objectToQueryString } from "src/helpers";
import { territoriesProps } from "./types";



const Territories: FC<territoriesProps> = ({ statisticsData,queryParam }): JSX.Element => {

  return (
    <div className="card p-0 mt-2">
      <div className="d-flex flex-column flex-fill">
        <div className="card-header order-1 ">
          <h4 className="p-0 mb-0 text-center " >Territories</h4>
        </div>
        <div className="order-2 card-body p-0 overflow-y-auto" style={{ maxHeight: 400 }}>
          <table className="table table-responsive table-hover" >
            <thead className="table-light space-between">
              <tr className="text-center">
                <th>Name</th>
                <th>Cases</th>
              </tr>
            </thead>
            <tbody>
              {statisticsData?.territories && statisticsData.territories.data && statisticsData.territories.data.length > 0 &&
                statisticsData?.territories.data.map((item, key) =>
                  <tr className="text-center" key={key}>
                    <td>
                      <Link
                        to={{
                          pathname: '/territories',
                          search: objectToQueryString({
                            id: item.id,
                            type: "territories",
                            role: item.role,
                            start_date: queryParam.start_date,
                            end_date : queryParam.end_date
                          })
                        }}
                        className="fw-normal fs-6 btn-link link-underline link-underline-opacity-0 link-offset-0-hover link-underline-opacity-75-hover"
                      >
                        {item?.name}
                      </Link>
                    </td>
                    <td>{item?.cases}</td>
                  </tr>
                )
              }
            </tbody>
            <tfoot>
              <tr className="text-center">
                <th>Total</th>
                <th>{statisticsData?.territories?.case_total}</th>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Territories;
